module.exports = __webpack_public_path__ + "static/img/教育.f88f013.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/system/assets/教育.png
// module id = KF4y
// module chunks = 3